import { Add as AddIcon } from "@mui/icons-material";
import OutboxIcon from "@mui/icons-material/Outbox";
import { Button, Stack, TextField, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

export type LoginsToolbarProps = {
	searchValue: string;
	onSearchChange: (value: string) => void;
	onCreateNewLogin: () => void;
	onResendAllVerificationEmails: () => void;
};

export const LoginsToolbar = ({
	searchValue,
	onSearchChange,
	onCreateNewLogin,
	onResendAllVerificationEmails,
}: LoginsToolbarProps) => {
	const { t } = useTranslation();

	return (
		<Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
			<TextField
				size="small"
				placeholder={t("search")}
				value={searchValue}
				onChange={(e) => onSearchChange(e.target.value)}
				sx={{ flex: 1 }}
				data-testid="logins-search-input"
			/>
			<Stack direction="row" spacing={1}>
				<Tooltip title={t("resend-verification-emails-to-all-unverified-users")}>
					<Button
						variant="contained"
						color="primary"
						onClick={onResendAllVerificationEmails}
						data-testid="resend-all-emails-button">
						<OutboxIcon />
					</Button>
				</Tooltip>
				<Button
					variant="contained"
					color="primary"
					onClick={onCreateNewLogin}
					startIcon={<AddIcon />}
					data-testid="create-new-login-button">
					{t("create-new-login")}
				</Button>
			</Stack>
		</Stack>
	);
};
